<template>
  <div class="stepper">
    <v-stepper light alt-labels v-model="step">
      <v-stepper-header>
        <v-stepper-step :step="1" :complete="step>1">Step 1 </v-stepper-step>
         <v-divider></v-divider>
        <v-stepper-step :step="2" :complete="step>2">Step 2</v-stepper-step>
         <v-divider></v-divider>
        <v-stepper-step :step="3" :complete="step>3">Step 3</v-stepper-step>
         <v-divider></v-divider>
        <v-stepper-step :step="4" :complete="step == 4">Step 4</v-stepper-step>
      </v-stepper-header>
    </v-stepper>
  </div>
</template>

<script>
export default {
  computed: {
    step() {
      return this.$route.params.step.replace('step-', '');
    },
  },
};
</script>
